import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Wrapper } from './Wrapper.js';

/** renders a Wrapper that is styled to fill the entire page */
var PageWrapper = function PageWrapper(props) {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    className: "page-wrapper"
  }));
};
PageWrapper.displayName = "PageWrapper";
export { PageWrapper };